<template>
  <div class="flex flex-wrap" :class="rowClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  noGutters?: boolean
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch'
  justify?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly'
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse'
}

const props = withDefaults(defineProps<Props>(), {
  noGutters: false,
  align: 'start',
  justify: 'start',
  direction: 'row',
})

const rowClasses = computed(() => ({
  'gap-0': props.noGutters,
  'gap-2': !props.noGutters,
  [`align-items-${props.align}`]: true,
  [`justify-content-${props.justify}`]: true,
  [`flex-${props.direction}`]: true,
}))
</script>

<style scoped></style>
